export default __webpack_public_path__ + "static/media/insert_link.90782370.png";